import authStore from "../store/modules/auth.store";

export default function auth({ next, router }) {

  const { userType } = authStore.state

  if (userType !== 'Admin') return router.push({ name: "401 Non autorisé" });

  return next();
}
